var isDev = "production" === 'development' || "production" === 'test';
export default isDev;